import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=4b175086&scoped=true&"
import script from "./detailPage.vue?vue&type=script&lang=js&"
export * from "./detailPage.vue?vue&type=script&lang=js&"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=4b175086&prod&lang=scss&scoped=true&"
import style1 from "./detailPage.vue?vue&type=style&index=1&id=4b175086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b175086",
  null
  
)

export default component.exports